module.exports = __webpack_public_path__ + "static/media/genesis.cd8d9c60.png";